import React from 'react';
import Button from '../../../../components/Button/Button';
import { usePatchFactSheetPublishMutation } from '@/services/fieldApi/FieldApi';
import { useToast } from '../../../../components/Toast/ToastContext';
import { useNavigate, useParams } from 'react-router-dom';
interface PublishFactSheetProps {
  closePopUp: () => void;
}

const PublishFactSheet: React.FC<PublishFactSheetProps> = ({ closePopUp }) => {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const { id } = useParams();
  const [PublishFactSheet, { isLoading }] = usePatchFactSheetPublishMutation();
  const handlePublishFactSheet = async () => {
    try {
      const response = await PublishFactSheet({
        id: id ?? '',
      }).unwrap();
      if (response.statusCode === 200) {
        addToast(
          'Plaintiff fact sheet published',
          'Plaintiff fact sheet is published successfully and available to all the districts.',
          'success'
        );
      }
      navigate('/plaintiffSheets');
      closePopUp();
    } catch (error) {
      addToast(
        'Publish failed',
        'Failed to publish plaintiff fact sheet. Please review the form and try again. ',
        'error'
      );
    }
  };
  return (
    <div>
      <p className="text-md text-ds-gray-500">
        Once published, this plaintiff fact sheet will become visible and accessible to all
        districts. Please ensure the information is complete and accurate before proceeding. Are you
        sure you want to continue?
      </p>

      <div className="mt-4 flex justify-end gap-2">
        <Button onClick={closePopUp}>Cancel</Button>
        <Button color="success" type="button" onClick={handlePublishFactSheet} loading={isLoading}>
          Publish
        </Button>
      </div>
    </div>
  );
};

export default PublishFactSheet;
